<template>
  <div class="fixed top-4 right-4 z-50 space-y-2">
    <TransitionGroup name="notification">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        :show="notification.show"
        @close="removeNotification(notification.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script>
import { useNotificationStore } from '@/stores/notification'
import Notification from './Notification.vue'

export default {
  name: 'NotificationManager',
  components: {
    Notification
  },
  setup() {
    const { notifications, removeNotification } = useNotificationStore()
    
    return {
      notifications,
      removeNotification
    }
  }
}
</script>

<style scoped>
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style> 